<!-- para mensajes de errores, etc-->
<p-toast key="msg" position="top-right"></p-toast>

<div class="text-center">

    <h2>MDG AUDIOVISUALES</h2>
    <h3 *ngIf="estadoActualizacion != undefined && estadoActualizacion==false">ACTIVACION DE USUARIO: <p-button label="DESFAVORABLE" badge="" severity="error"/></h3>
    <h3 *ngIf="estadoActualizacion != undefined && estadoActualizacion==true">ACTIVACION DE USUARIO: <p-button label="FAVORABLE" badge="" severity="success" /></h3>
</div>